<template>
  <div>
    <v-card>
      <div class="pa-4">
        <h4>Featured</h4>
      </div>
      <v-divider></v-divider>
      <div
        v-if="userLoading"
        class="d-flex align-items-center justify-center py-5"
      >
        <v-progress-circular indeterminate />
      </div>
      <v-row v-else class="pa-8">
        <v-col v-for="(user, k) of fusers" :key="k" md="6" cols="12">
          <div class="border">
            <div class="d-flex align-center">
              <div class="d-inline-block avatar-wrapper">
                <v-avatar
                  @click="() => viewProfile(user)"
                  class="mr-2"
                  v-if="user.profile_image"
                  size="72"
                  ><img :src="user.profile_image"
                /></v-avatar>
                <v-avatar
                  @click="() => viewProfile(user)"
                  class="mr-2"
                  v-else
                  size="72"
                  ><img src="/images/default-profile.jpg"
                /></v-avatar>
                <div class="avatar-icon"><i class="fa fa-trophy"></i></div>
              </div>
              <h4 class="ma-0" @click="() => viewProfile(user)">
                {{ user.firstname }} {{ user.lastname }}
              </h4>
            </div>
            <div class="d-flex mt-4">
              <b>Creator Type:</b>
              <v-chip-group class="ml-auto">
                <v-chip
                  v-for="(type, k) of user.creator_type"
                  :key="k"
                  x-small
                  :class="{
                    'mr-0': k == user.creator_type.length - 1,
                  }"
                  >{{ type }}</v-chip
                >
              </v-chip-group>
            </div>
            <div class="d-flex align-items-center">
              <b>Country:</b>
              <small class="ml-auto">{{ user.country }}</small>
            </div>
            <div class="d-flex align-items-center">
              <b>City:</b>
              <small class="ml-auto">{{ user.city }}</small>
            </div>
            <div class="d-flex align-items-center">
              <b>Experience:</b>
              <small class="ml-auto">{{ user.experience }}</small>
            </div>
            <div class="d-flex align-items-center">
              <b>Genre:</b>
              <v-chip-group class="ml-auto">
                <v-chip
                  v-for="(genre, k) of user.genre"
                  :key="k"
                  x-small
                  :class="{
                    'mr-0': k == user.genre.length - 1,
                  }"
                  >{{ genre }}</v-chip
                >
              </v-chip-group>
            </div>
            <div class="d-flex align-items-center">
              <b>Weekly Challenge Winner:</b>
              <small class="ml-auto">{{ user.title }}</small>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
export default {
  mounted() {
    this.getUsers();
  },
  methods: {
    viewProfile(user) {
      if (user.user_id == this.getLoggedUser().id) {
        this.$router.push("/profile");
      } else {
        this.getSocialUser(user.user_id);
        this.$router.push(`/profile/${user.id}`);
      }
    },
  },
};
</script>

<style scoped>
.border {
  border: 1px solid rgba(0, 0, 0, 0.2);
  padding: 10px;
  border-radius: 6px;
}
.avatar-wrapper {
  position: relative;
}
.avatar-icon {
  position: absolute;
  top: 0;
  left: 0;
  border-radius: 50%;
  color: #ffffff;
  width: 22.5px;
  height: 22.5px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: green;
  font-size: 12px;
  border: 0 !important;
}
</style>